import { IS_INCLUSIVE_BETW_JULY1_TO_SEPT_15 } from "@/reports/constants";

export interface DateRangeTranslations {
  value: string;
  min: string;
  max: string;
  label: string;
  copy?: string;
}

export type DateRangeTranslatedValues = [
  DateRangeTranslations,
  DateRangeTranslations,
  DateRangeTranslations,
  DateRangeTranslations,
  ...DateRangeTranslations[],
];

const getDefaultDateRange = (
  dateRangeTranslatedValues: DateRangeTranslatedValues,
): [string, string] => {
  let defaultOption;
  if (dateRangeTranslatedValues.length < 4) {
    // For admin reporting
    // if between and including july 1st and sept 15, the default is 45 days, else default is july to date
    defaultOption = IS_INCLUSIVE_BETW_JULY1_TO_SEPT_15
      ? dateRangeTranslatedValues[3]
      : dateRangeTranslatedValues[0];
  } else {
    // For teacher reporting
    // if between and including july 1st and sept 15, the default is 90 days, else default is july to date
    defaultOption = IS_INCLUSIVE_BETW_JULY1_TO_SEPT_15
      ? dateRangeTranslatedValues[1]
      : dateRangeTranslatedValues[0];
  }
  return [defaultOption.min, defaultOption.max];
};

export const getMinMaxDates = (
  selectedDateRange: string | undefined,
  dateRangeTranslatedValues: DateRangeTranslatedValues,
  selectedMinDate?: string | undefined,
  selectedMaxDate?: string | undefined,
): [string, string] => {
  if (selectedDateRange === undefined) {
    return getDefaultDateRange(dateRangeTranslatedValues);
  } else if (
    selectedDateRange === "custom" &&
    selectedMinDate &&
    selectedMaxDate
  ) {
    return [selectedMinDate, selectedMaxDate];
  } else {
    const selectedDates = dateRangeTranslatedValues.find(
      (date) => date.value === selectedDateRange,
    );
    // check if user included unexpected url param for date range
    if (
      selectedDates === undefined ||
      (IS_INCLUSIVE_BETW_JULY1_TO_SEPT_15 &&
        selectedDates.value === "july_to_date")
    ) {
      return getDefaultDateRange(dateRangeTranslatedValues);
    }
    return [selectedDates.min, selectedDates.max];
  }
};

export const getSelectedDateText = (
  selectedDateRange: string | undefined,
  dateRangeTranslatedValues: DateRangeTranslatedValues,
) => {
  let defaultOption;
  if (dateRangeTranslatedValues.length < 4) {
    defaultOption = IS_INCLUSIVE_BETW_JULY1_TO_SEPT_15
      ? dateRangeTranslatedValues[3]
      : dateRangeTranslatedValues[0];
  } else {
    defaultOption = IS_INCLUSIVE_BETW_JULY1_TO_SEPT_15
      ? dateRangeTranslatedValues[1]
      : dateRangeTranslatedValues[0];
  }
  if (selectedDateRange === undefined) {
    return {
      filterLabel: defaultOption.label,
      copy: defaultOption.copy,
    };
  } else {
    const selectedDates = dateRangeTranslatedValues.find(
      (date) => date.value === selectedDateRange,
    );
    // check if user included unexpected url param for date range
    if (selectedDates === undefined) {
      return {
        filterLabel: defaultOption.label,
        copy: defaultOption.copy,
      };
    }
    return {
      filterLabel: selectedDates.label,
      copy: selectedDates.copy,
    };
  }
};
